<template>
  <ib-guided-tour
    tour-name="financialPlanTour"
    :steps="tourSteps"
    :show-intro-dialog="showIntroDialog"
    :intro-delay="1000"
    @tour-start="$emit('tour-start')"
    @tour-end="$emit('tour-end')"
    @intro-skip="$emit('intro-skip')"
  >
    <template #intro-image>
      <img src="@/assets/img/onboarding/idea.svg" alt="" style="width: 125px;">
    </template>
    <template #intro>
      <h1 class="text-center mb-2 font-outfit-semi-bold">
        {{ $t('pages.financialPlan.tour.introTitle') }}
      </h1>
      <p class="text-center" style="font-size: 18px;">
        {{ $t('pages.financialPlan.tour.introText') }}
      </p>
    </template>
  </ib-guided-tour>
</template>

<script>
export default {
  name: 'FinancialsTour',

  props: {
    showIntroDialog: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    tourSteps () {
      return [
        {
          target: '.d-flex.router-link-active',
          header: { title: this.$t('pages.financialPlan.tour.step1Title') },
          content: this.$t('pages.financialPlan.tour.step1Content'),
          params: {
            placement: 'bottom',
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: '.flex-wrap:nth-child(3) .mb-4 .ib-card-wrapper',
          header: { title: this.$t('pages.financialPlan.tour.step2Title') },
          content: this.$t('pages.financialPlan.tour.step2Content'),
          params: {
            placement: 'right',
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: '.flex-wrap:nth-child(3) .d-flex:nth-child(2) .ib-card-wrapper',
          header: { title: this.$t('pages.financialPlan.tour.step3Title') },
          content: this.$t('pages.financialPlan.tour.step3Content'),
          params: {
            placement: 'left',
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: '.steps-navigation-buttons-wrapper:nth-child(2) .export-button',
          header: { title: this.$t('pages.financialPlan.tour.step4Title') },
          content: this.$t('pages.financialPlan.tour.step4Content'),
          params: {
            placement: 'bottom',
            enableScrolling: false,
            highlight: true
          }
        }
      ]
    }
  }
}
</script>
